import { concat, } from "rxjs";
import { publish, take } from "rxjs/operators";
export function subsequent(countOrOperator, operator) {
    let count;
    if (typeof countOrOperator === "number") {
        count = countOrOperator;
    }
    else {
        count = 1;
        operator = countOrOperator;
    }
    return (source) => source.pipe(publish((published) => concat(published.pipe(take(count)), published.pipe(operator))));
}
//# sourceMappingURL=subsequent.js.map